var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.29999C0 1.07908 0.179086 0.899994 0.4 0.899994H17.6C17.8209 0.899994 18 1.07908 18 1.29999V2.69999C18 2.92091 17.8209 3.09999 17.6 3.09999H0.4C0.179086 3.09999 0 2.92091 0 2.69999V1.29999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.29999C0 8.07908 0.179086 7.89999 0.4 7.89999H17.6C17.8209 7.89999 18 8.07908 18 8.29999V9.69999C18 9.92091 17.8209 10.1 17.6 10.1H0.4C0.179086 10.1 0 9.92091 0 9.69999V8.29999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3C0 15.0791 0.179086 14.9 0.4 14.9H17.6C17.8209 14.9 18 15.0791 18 15.3V16.7C18 16.9209 17.8209 17.1 17.6 17.1H0.4C0.179086 17.1 0 16.9209 0 16.7V15.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.a5ec2106794e5f7786e90ae009b0e9fd.svg";
export { ForwardRef as ReactComponent };